import { getSiteSharing, siteSharingOnDevice } from './operatorSitePresence';
import { registerPlugin } from '@capacitor/core';
import { getNativeIosLinkedUser, getNativeIosInstallId } from './nativeApiRouting';
import { isIosNativeAppRuntime } from './runtimeCapabilities';
import { getSharingCompanies, sharesOnThisDevice, workforceUserId } from './workforceLocation';
export type NativeWorkforceStatus = {available:boolean;enabled:boolean;ready:boolean;preciseAllowed:boolean;lastDeliveredAt:string;message:string;siteSharingSupported?:boolean;siteReady?:boolean};
const native = registerPlugin<{configure(options:unknown):Promise<NativeWorkforceStatus>;getStatus():Promise<NativeWorkforceStatus>;openSettings():Promise<void>}>('ZiaWorkforceLocation');
const key=()=>`zia:workforce-background:${workforceUserId()}`;
export const backgroundSharingRequested=()=>{try{return localStorage.getItem(key())==='true';}catch{return false;}};
export async function nativeWorkforceStatus():Promise<NativeWorkforceStatus|null>{
  if(!isIosNativeAppRuntime())return null;
  try{return await native.getStatus();}catch{return null;}
}
let generation=0;
/** Stop immediately on account/consent changes; delayed lookups can never turn a previous session back on. */
export async function syncNativeWorkforce(requestAuthorization=false):Promise<NativeWorkforceStatus|null>{
  if(!isIosNativeAppRuntime())return null;
  const version=++generation;
  const user=getNativeIosLinkedUser();
  try{
    await native.configure({targets:[]});
    if(!user?.sessionToken)return await native.getStatus();
    const [companyResult,siteResult]=await Promise.allSettled([backgroundSharingRequested()?getSharingCompanies():Promise.resolve({companies:[]}),getSiteSharing()]);
    const companies=companyResult.status==='fulfilled'?companyResult.value.companies:[];
    const site=siteResult.status==='fulfilled'?siteResult.value:null;
    const siteTarget=site && site.backgroundAllowed && siteSharingOnDevice(site,user.userId) && (site.duration==='12h'||site.duration==='24h')?site:null;
    if(version!==generation||user.userId!==getNativeIosLinkedUser()?.userId)return null;
    return await native.configure({siteTarget,targets:companies.filter(company=>sharesOnThisDevice(company,user.userId)),userId:user.userId,
      sessionToken:user.sessionToken,installId:getNativeIosInstallId(),requestAuthorization});
  }catch{return null;}
}
export async function setNativeWorkforce(enabled:boolean){
  localStorage.setItem(key(),String(enabled));return syncNativeWorkforce(enabled);
}

export const openWorkforceLocationSettings=()=>native.openSettings();

export async function stopNativeWorkforce(){
  generation++;
  if(!isIosNativeAppRuntime())return;
  try{await native.configure({targets:[]});}catch{ /* Older app builds do not have the plugin. */ }
}
